/**
 * Allows attaching events to elelments, when they enter or leave viewport.
 * LEGACY: SHOULD BE REWRITTEN FOR A BETTER API AND USE intersectionObserver.
 */
import { inViewport, scrollY } from 'verge'
import { warn } from '../application/console'
import { noop, makeSafeFn } from '../utils/fn'
import BaseClass from '../application/BaseClass'
import { addDocumentEvent, removeDocumentEvent } from '../utils/dom'

const SCROLLING_CONSTS = {
  top: 'top',
  bottom: 'bottom',
}

class ScrollingEventsProvider extends BaseClass {
  register(eventDefinitionObject) {
    if (eventDefinitionObject.element) {
      const scrollingEventConf = this.calculateEventVariables(eventDefinitionObject)
      this.addScrollingEvent(scrollingEventConf.handler)
      return scrollingEventConf.handler
    }
    return noop
  }

  addScrollingEvent(scrollingEventConf, useCapture) {
    addDocumentEvent('scroll', scrollingEventConf, useCapture || false)
  }

  removeScrollingEvent(scrollingEventConf, useCapture) {
    removeDocumentEvent('scroll', scrollingEventConf, useCapture || false)
  }

  triggerEventOnce(eventConfig) {
    const { isInViewport, triggerFlag, triggerEvent, customCondition, store } = eventConfig
    let activeFlag
    if (!store[triggerFlag] && !isInViewport && customCondition) {
      activeFlag = true
    } else if (store[triggerFlag] && isInViewport) {
      activeFlag = false
    }
    this.emitEvent({ triggerFlag, triggerEvent, store, activeFlag })
  }

  emitEvent({ triggerFlag, triggerEvent, store, activeFlag }) {
    store[triggerFlag] = activeFlag
    store[triggerEvent]()
    return this
  }

  getCalculatedHeightBreakpoint(eventConfig) {
    const { element, triggerPosition, relativeTopElement } = eventConfig
    const safeGetComputedHeight = makeSafeFn(function getElComputedHeight(el) {
      return parseFloat(getComputedStyle(el).height)
    })
    const doElementsExist = Boolean(element && relativeTopElement)
    if (!doElementsExist) {
      warn(
        'scrollingEventsProvider eventConfig is misconfigured: at least one element is missing!',
        { eventConfig, doElementsExist }
      )
    }
    const height = doElementsExist ? safeGetComputedHeight(element) || 0 : 0
    const relativeTopElementHeight = doElementsExist
      ? safeGetComputedHeight(relativeTopElement) || 0
      : 0
    let heightPercentage
    let deltaHeight
    switch (Object.getOwnPropertyNames(triggerPosition)[0]) {
      case SCROLLING_CONSTS.top:
        heightPercentage = triggerPosition.top
        deltaHeight = height - height * (heightPercentage / 100)
        break
      case SCROLLING_CONSTS.bottom:
        heightPercentage = triggerPosition.bottom
        deltaHeight = height - height * ((100 - heightPercentage) / 100)
        break
      default:
        deltaHeight = 0
    }
    return { deltaHeight, relativeTopElementHeight }
  }

  checkIfElementInViewport(eventConfig) {
    const heightBreakpoint = this.getCalculatedHeightBreakpoint(eventConfig)

    return inViewport(
      eventConfig.element,
      -heightBreakpoint.relativeTopElementHeight - heightBreakpoint.deltaHeight
    )
  }

  parseEventConfig(eConfig, objectWithHandler) {
    const { vm, event: actionCallerFn, payload, fireOnlyOnce } = eConfig
    const isInViewport = this.checkIfElementInViewport(eConfig)
    eConfig.previousInViewportFlag =
      eConfig.previousInViewportFlag === undefined ? isInViewport : eConfig.previousInViewportFlag
    if (eConfig.previousInViewportFlag !== isInViewport) {
      vm[actionCallerFn]({ ...payload, sub_label: scrollY() } || isInViewport)

      if (fireOnlyOnce) {
        this.removeScrollingEvent(objectWithHandler.handler)
      }
      eConfig.previousInViewportFlag = isInViewport
    }
    return this
  }

  calculateEventVariables(eventConfig) {
    const obj = {}
    const handler = this.parseEventConfig.bind(this, eventConfig, obj)
    return Object.assign(obj, { handler })
  }
}

const scrollingEventsProvider = ScrollingEventsProvider.create()

export default scrollingEventsProvider



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/scrollingEventsProvider.js